import CreateIcon from "@components/Icon/components/CreateIcon";
import { IconProps } from "@components/Icon/utils/types";

/** Renders an SVG icon based on the provided type and properties.**/
const IconFactory = ({
  type,
  className = "",
  size = 24,
  x,
  y,
}: IconProps): React.ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${x || 24} ${y || 24}`}
      className={className}
      style={{ width: size, height: size }}
    >
      <CreateIcon type={type} />
    </svg>
  );
};

export default IconFactory;
